/**
 * Handler to clear discounts for guest users across the entire site.
 */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Check if meowcart config is available
    if (typeof meowcart === 'undefined') return;

    // Safety check for Shopify routes
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        // Condition: If there's a discount applied but no user is logged in
        // We only want to clear it if it looks like a loyalty discount
        const loyaltyPrefixes = ['THE1_', 'CRS_', 'crs_', 'POINT_', 'VOUCHER_'];
        const appliedDiscounts = cart.cart_level_discount_applications || [];

        const hasLoyaltyDiscount = appliedDiscounts.some(discount => {
          const title = discount.title.toUpperCase();
          return loyaltyPrefixes.some(prefix => title.startsWith(prefix));
        });

        // Fallback: if we can't see the titles but there's a total discount, 
        // we might still want to clear it, but we MUST avoid a loop.
        // update 7.7 fix giftbox
        // const hasGenericDiscount = cart.total_discount > 0;
        
        if (hasLoyaltyDiscount) {
          // Safeguard: prevent infinite reload loops
          const reloadCount = parseInt(sessionStorage.getItem('loyalty_guest_reload_count') || '0');
          if (reloadCount > 1) {
            console.warn('[Loyalty] Potential reload loop detected. Stopping guest discount cleanup.');
            return;
          }

          console.log('[Loyalty] Guest detected with active discounts. Clearing...');
          
          let url = meowcart.api_url + meowcart.endpoints.shopify.updateDiscount;
          if (url.includes("/the1/shopify")) {
            url = url.replace("/the1/shopify", "/shopify");
          }

          fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              cartId: cart.token,
              discountCodes: [""]
            })
          }).then(response => {
            if (response.ok) {
              console.log('[Loyalty] Discounts cleared for guest.');
              if (window.location.pathname.includes('/cart')) {
                sessionStorage.setItem('loyalty_guest_reload_count', (reloadCount + 1).toString());
                // window.location.reload();
              }
            }
          }).catch(err => console.error('[Loyalty] Error clearing guest discounts:', err));
        } else {
          // Reset counter if no discounts are found
          sessionStorage.removeItem('loyalty_guest_reload_count');
        }
      })
      .catch(err => console.error('[Loyalty] Error fetching cart for guest cleanup:', err));
  });
})();
